// Getters
const namespace = 'navigation/'

export const GET_MENU_OPEN = 'getMenuOpen'
export const NAV_GET_MENU_OPEN = namespace + GET_MENU_OPEN
export const GET_SEARCH_QUERY = 'getSearchQuery'
export const NAV_GET_SEARCH_QUERY = namespace + GET_SEARCH_QUERY
export const GET_FILTERED_MENU_ITEMS = 'getFilteredMenuItems'
export const NAV_GET_FILTERED_MENU_ITEMS = namespace + GET_FILTERED_MENU_ITEMS

// Mutations
export const SET_MENU_OPEN = 'setMenuOpen'
export const NAV_SET_MENU_OPEN = namespace + SET_MENU_OPEN
export const SET_SEARCH_QUERY = 'setSearchQuery'
export const NAV_SET_SEARCH_QUERY = namespace + SET_SEARCH_QUERY



// WEBPACK FOOTER //
// ./src/store/navigation/nav.types.js